module.exports = __webpack_public_path__ + "templates/points-assign.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/points/templates/points-assign.html
// module id = x3yK
// module chunks = 1